var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBehance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.869,
    height: 36.869,
    viewBox: "0 0 36.869 36.869",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#cbcbcb;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.64,23.058H9.217V19.971H12.69C15.575,19.971,15.767,23.058,12.64,23.058Zm10.382-4.112h4.636A2.327,2.327,0,0,0,23.021,18.946Zm-10.452-5.12H9.217V16.9h3.67C15.457,16.9,15.863,13.826,12.569,13.826Zm24.3-6.145V29.188a7.681,7.681,0,0,1-7.681,7.681H7.681A7.681,7.681,0,0,1,0,29.188V7.681A7.681,7.681,0,0,1,7.681,0H29.188A7.681,7.681,0,0,1,36.869,7.681ZM21.507,12.29h7.681V10.753H21.507ZM16.05,17.848c2.93-1.5,2.822-6.99-2.785-7.073H6.145V26.1h6.623C19.714,26.1,19.6,19.138,16.05,17.848Zm14.574.925a5.137,5.137,0,0,0-5.5-4.532c-3.217,0-5.149,2.058-5.149,6.063,0,4.042,2.1,5.811,5.248,5.811s4.771-1.744,5.223-3.072H27.2a2.525,2.525,0,0,1-4.251-2.078h7.773a13.807,13.807,0,0,0-.1-2.192Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehance);
export default __webpack_public_path__ + "static/media/behance.9c6fd07b1967fc7cb889692fff250178.svg";
export { ForwardRef as ReactComponent };